import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { common_axios } from "../../../../App";
import { Backdrop, Box, CssBaseline, Skeleton, TextField } from "@mui/material";
import Loader from "../../../../components/Loader";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function RoutesSelect({
  parentCallback,
  emptyArray,
  categoryy,
}) {
  const [variantName, setVariantName] = React.useState([]);
  const [variants, setVariants] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const documentsupload = async () => {
    setOpen(true);

    try {
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/routes`
      );

      if (res.data.statusDescription.statusCode == 200) {
        console.log("TTTTTTTTTTT", { categoryy });
        const filterData = res.data.listOfRoutes.filter((dd, index) => {
          if (categoryy == "" || categoryy == null) return dd;
          return dd.category == categoryy;
        });
        setVariants(filterData);
        setOpen(false);
      } else {
        setOpen(false);
      }
    } catch (err) {
      console.log({ err });
      setOpen(false);
    }
  };
  React.useEffect(() => {
    documentsupload();
  }, [categoryy]);

  React.useEffect(() => {
    if (emptyArray) {
      setVariantName([]);
    }
  }, [emptyArray]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    let duplicateRemoved = [];

    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });

    setVariantName(duplicateRemoved);
  };

  const sendData = () => {
    parentCallback(variantName);
  };

  React.useEffect(async () => {
    sendData();
  }, [sendData]);

  React.useEffect(async () => {
    setVariantName([]);
  }, [variants]);

  console.log(variants);

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop>
      <div className="w-100">
        {categoryy != "" && categoryy != null && (
          <>
            {variants.length == 0 ? (
              <TextField
                fullWidth
                disabled
                type="text"
                label="Reason"
                name="Search"
                variant="outlined"
                // value={number}
                size="small"
                value={`No Route Available for ${categoryy}`}
              />
            ) : (
              <FormControl required fullWidth size="small">
                <InputLabel id="demo-multiple-checkbox-label">
                  Select Routes
                </InputLabel>
                <Select
                  required
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={variantName}
                  onChange={handleChange}
                  input={<OutlinedInput label="Select Routes" />}
                  renderValue={(selected) =>
                    selected.map((x) => x.routeName).join(", ")
                  }
                  MenuProps={MenuProps}
                >
                  {variants == undefined ? (
                    <>
                      <Box className="w-100">
                        <Skeleton animation="wave" />
                        <Skeleton animation={true} />
                        <CssBaseline />
                      </Box>
                    </>
                  ) : (
                    variants.map((variant) => {
                      console.log(variant);
                      return (
                        <MenuItem key={variant.id} value={variant}>
                          <Checkbox
                            checked={
                              variantName.findIndex(
                                (item) => item.id === variant.id
                              ) >= 0
                            }
                          />
                          <ListItemText primary={variant.routeName} />
                        </MenuItem>
                      );
                    })
                  )}
                </Select>
              </FormControl>
            )}
          </>
        )}
      </div>
    </main>
  );
}
